































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ChannelLimitedTypeEnum } from '../../shared/types/Channel'
import { IChannelSubscriptionInfo } from './types'

@Component({})
export default class ChannelSubscriptionInfo extends Vue {
  @Prop() channelTitle!: string

  @Prop() channelId!: number

  @Prop() channelSubscriptionType!: ChannelLimitedTypeEnum

  @Prop() getChannelSubscriptionLink!: IChannelSubscriptionInfo['getChannelSubscriptionLink']

  gotoSettings() {
    if (this.channelId) {
      window.open(this.getChannelSubscriptionLink(this.channelId), '_blank')
    }
  }
}
